import 'firebase/auth';
import axios from '@/axios';
import axiosLib from 'axios';
import { currentUserIsNurse } from '@/globalHelpers/userRole';

export default {
  fetchPatients(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/doctors/patients', { params: data })
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  patientDetail(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/patientDetail/' + data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  patientDetail2(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/patientAllDetails/' + data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  updatePatientDetail(_context, data) {
    const url = currentUserIsNurse() 
    ? '/api/v1/patients/update' 
    : '/api/v1/doctors/patients/update';
    
    return new Promise((resolve, reject) => {
      axios
        .put(url, data.data , { params: data.params })
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  createPatient(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/doctors/patients/createPatientByDoctor' ,  data )
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  patientTreatmentList(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/patients/treatmentHistory', {
          params: data,
        })
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  patientTreatmentList2(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/patients/treatmentHistory/emr', {
          params: data,
        })
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchNursePatients(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/nurses/patients/webPortal', { params: data })
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },

  fetchFranchisePatient(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/franchises/patient-list?page=' +
          data.page +
          '&limit=' +
          data.limit +
          '&search=' +
          data.search +
          '&sort=' +
          data.sort +
          '&dir=' +
          data.dir +
          '&filter=' +
          data.filter
        )
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAllPatients(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/admins/patientList?page=' +
          data.page +
          '&limit=' +
          data.limit +
          '&search=' +
          data.search +
          '&sort=' +
          data.sort +
          '&dir=' +
          data.dir +
          '&activeClinicId=' +
          data.activeClinicId
        )
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getPatientFiles(_, patientId) {
    return axios.get('/api/v1/patients/files', {
      params: { patientId },
    });
  },

  createPatientFile(_context, data) {
    const payload = {
      patientId: data.patientId,
      files: data.files.map(file => ({
        name: file.name,
        url: file.url,
        type: file.type,
      })),
    };

    return axios.post('/api/v1/patients/files', payload);
  },

  deletePatientFile(_, fileId) {
    return axios.delete(`/api/v1/patients/files/${fileId}`);
  },

  exportCsv(_context, data) {
    return new Promise((resolve, reject) => {
      let url = '/api/v1/admins/patient-export-csv?page=' + data.page +
          '&limit=' + data.limit +
          '&exportMode=' + data.exportMode;

      if(data.clinicId) {
        url = url + '&clinicId=' + data.clinicId;
      }

      axios
        .post(url)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchPresignedUrl(_, data) {
    return  axios.get('/api/v1/patients/upload-signed-url', {
      params: {
        filename: data.filename,
        patientId: data.patientId,
        contentType: data.contentType,
      },
    });
  },
  async uploadFileToPresignedUrl(_, data) {
    const { presignedUrl, file, onUploadProgress } = data;
    
    const axiosInstance = axiosLib.create({
      headers: {
        'Content-Type': file.type,
      },
    });

    const result = await axiosInstance.put(presignedUrl, file, {
      onUploadProgress: onUploadProgress || ((progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        console.log(`File upload is ${percentCompleted}% completed.`);
      }),
    });
    return result;
  },
};
